
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tooling",
      function () {
        return require("private-next-pages/tooling.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tooling"])
      });
    }
  